import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import globalStore from '@/services/global.state';
import {RechargeWebRulePanel} from '@fe-progressive/package-progressive/recharge-web';
import {normalizeProgressivePackageLocale} from '@fe-progressive/package-progressive/locale';
import {useRechargeWebRulePanelData} from '../use-recharge-web-rule-panel';

interface RechargeRuleProps {
  fromWeekCard?: boolean;
  /** 未传时使用 `globalStore.currency` */
  currencySymbol?: string;
}

const RechargeRule: React.FC<RechargeRuleProps> = ({
  fromWeekCard = false,
  currencySymbol: currencySymbolProp,
}) => {
  const {i18n} = useTranslation();
  const progressiveLocale = useMemo(
    () => normalizeProgressivePackageLocale(i18n.language),
    [i18n.language],
  );
  const {waterMultiplier, weekCardConfigs} = useRechargeWebRulePanelData();
  const currencySymbol = currencySymbolProp ?? globalStore.currency;

  return (
    <RechargeWebRulePanel
      waterMultiplier={waterMultiplier}
      weekCardConfigs={weekCardConfigs}
      fromWeekCard={fromWeekCard}
      locale={progressiveLocale}
      currencySymbol={currencySymbol}
    />
  );
};

export default RechargeRule;
